<template>
  <li
    class="sai-list"
    :class="selected && 'selected'"
  >
    <div
      class="sai-faq-item"
      :class="index === 0 && 'first'"
      :style="{ animationDelay: `${index < 20 ? 0.05 * (index + 1) : 0}s` }"
      @click="selectItem(item)"
    >
      <div class="sai-faq-item__wrapper">
        <div class="sai-faq-item__wrapper__content">
          <div class="sai-faq-item__wrapper__content__ancesters">
            <span
              class="sai-faq-item__wrapper__content__ancesters__ancester"
              v-for="(ancester, index) in item.ancesters"
              :key="index"
            >
              {{ ancester.text }}
              <span v-if="index < item.ancesters.length - 1">&gt;</span>
            </span>
          </div>
          <div class="sai-faq-item__wrapper__content__title">
            <div class="sai-faq-item__wrapper__content__title__text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="sai-faq-item__wrapper sp">
        <div class="sai-faq-item__wrapper__content">
          <div class="sai-faq-item__wrapper__content__ancesters">
            <span
              class="sai-faq-item__wrapper__content__ancesters__ancester"
              v-for="(ancester, index) in item.ancesters"
              :key="index"
            >
              {{ ancester.text }}
              <span v-if="index < item.ancesters.length - 1">&gt;</span>
            </span>
          </div>
        </div>
        <div class="sai-faq-item__wrapper__content__title">
          <div class="sai-faq-item__wrapper__content__title__text">
            {{ item.text }}
          </div>
        </div>
      </div>
      <div
        class="sai-faq-item__icon"
        v-show="selected"
      >
        <img src="../resource/sai-icon_shape.png" />
      </div>
    </div>
    <div
      class="sai-faq-result"
      v-show="selected"
    >
      <div
        class="sai-faq-result__content"
        v-if="item.viewType === 'scenario'"
        v-for="(scenario, s_idx) in scenarios"
        :key="s_idx"
      >
        <Scenario
          v-if="scenario.viewType === 'scenario'"
          :item="scenario"
          :index="s_idx"
          @selectChoice="selectChoice"
        />
        <Result
          v-if="scenario.viewType === 'result'"
          :item="scenario"
          @resetItem="resetItem"
        />
      </div>
      <div
        class="sai-faq-result__content"
        v-if="item.viewType === 'result'" >
        <Result
          :item="item"
          @resetItem="resetItem"
        />
      </div>
    </div>
  </li>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import dataResource from '@/common/dataResource';
import { eventBus } from '@/eventBus';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    item: Object,
    index: Number,
    action: String,
  },
})
export default class FaqItem extends Vue {
  selected = false;
  scenarios = [];

  get isResult() {
    this.item.viewType === 'result';
  }

  @Watch('selected')
  onChangeResultHeight() {
    eventBus.$emit('initFeedbackData');
    setTimeout(() => {
      eventBus.$emit('updateRecommendHeight');
    }, 0);
  }

  @Watch('scenarios')
  onChangeScenarios() {
    eventBus.$emit('initFeedbackData');
  }

  async selectItem(item) {
    if (this.$store.state.user.isIphone && this.$store.state.onIME) {
      eventBus.$emit('toggleIme', false);
      return;
    }

    // Already selected
    if (this.selected) {
      this.resetItem();
      this.publishOpenTicket();
      return;
    }

    // Page transition
    const isPageTransition = await this.transitionItem(item);
    if (isPageTransition) {
      this.$emit('setTagSearchShow', false);
      await this.publishFaqTicket(item);
      await this.movePage(item);
      return;
    }

    // Open selected item
    if (item.resourceName === 'scenario') {
      const scenario = await dataResource.getItem(item);
      Object.assign(item.items, scenario.items);
      this.scenarios.push(scenario);
    }
    this.selected = true;
    this.publishFaqTicket(item);
  }
  resetItem() {
    this.selected = false;
    this.scenarios = [];
  }
  transitionItem(item) {
    const reg = /^http|^https/;
    return item.talkScriptId && item.caption.match(reg);
  }
  movePage(item) {
    window.location.href = item.caption;
  }
  async publishFaqTicket(item) {
    this.$store.commit('ticket/setResetFlag', true);
    const newTicket = await this.updateFaqTicket({ item: item, faqAction: this.action });
    await this.$ticket.setData(newTicket);
    await this.$ticket.post();
  }
  updateFaqTicket({ item, faqAction }) {
    const startTime =
      this.$store.state.ticket.startTime || String(new Date().getTime());
    this.$store.commit('ticket/setStartTime', startTime);
    const historyAction = { type: '', value: faqAction };
    this.$store.commit('ticket/addHistoryActionFaqChannel', historyAction);
    const keywordTags = this.$store.getters['tagSearch/selectedKeywordTags'];
    const tagActiveSet =
      keywordTags.length === 0
        ? []
        : keywordTags.map(t => {
            const v = { id: t.id, text: t.text };
            if (t.displayText) {
              v.label = t.displayText;
            }
            return v;
          });
    if (
      keywordTags.length > 0 &&
      this.$store.state.ticket.tagUsedSet.length === 0
    ) {
      this.$store.commit('ticket/setTagUsedSet', tagActiveSet);
    }
    const query = this.$store.state.tagSearch.searchText;
    if (query && this.$store.state.ticket.historyQuery.length === 0) {
      this.$store.commit('ticket/setHistoryQuery', [query]);
    }
    return this.generateFaqTicket(item, startTime, query, tagActiveSet);
  }
  generateFaqTicket(item, startTime, query, tagActiveSet) {
    const commonTicket = {
      origin: 'window',
      user_agent: this.$store.state.user.userAgent,
      user_id: this.$store.state.user.Id,
      start_time: startTime,
      end_time: String(new Date().getTime()),
      query: query,
      tag_active_set: tagActiveSet,
      tag_used_set: this.$store.state.ticket.tagUsedSet,
      history_query: this.$store.state.ticket.historyQuery,
      history_action_faq_channel: this.$store.state.ticket
        .historyActionFaqChannel,
    };

    let newTicket = {
      ...commonTicket,
      status: item.viewType === 'result' ? 'answered' : 'answering',
      items: item.items,
    };
    if (item.viewType === 'result') {
      newTicket.status_feedback = 'open';
    }

    return newTicket;
  }
  async publishOpenTicket() {
    if (this.$store.state.ticket.resetFlag) {
      eventBus.$emit('resetTicket');
      return;
    }
    const newTicket = await this.updateOpenTicket();
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
  updateOpenTicket() {
    const startTime =
      this.$store.state.ticket.startTime || String(new Date().getTime());
    this.$store.commit('ticket/setStartTime', startTime);
    const keywordTags = this.$store.getters['tagSearch/selectedKeywordTags'];
    const tagActiveSet =
      keywordTags.length === 0
        ? []
        : keywordTags.map(t => {
            const v = { id: t.id, text: t.text };
            if (t.displayText) {
              v.label = t.displayText;
            }
            return v;
          });
    if (
      keywordTags.length > 0 &&
      this.$store.state.ticket.tagUsedSet.length === 0
    ) {
      this.$store.commit('ticket/setTagUsedSet', tagActiveSet);
    }
    const query = this.$store.state.tagSearch.searchText;
    if (query && this.$store.state.ticket.historyQuery.length === 0) {
      this.$store.commit('ticket/setHistoryQuery', [query]);
    }
    return this.generateOpenTicket(startTime, query, tagActiveSet);
  }
  generateOpenTicket(startTime, query, tagActiveSet) {
    const newTicket = {
      origin: 'window',
      user_agent: this.$store.state.user.userAgent,
      user_id: this.$store.state.user.Id,
      start_time: startTime,
      end_time: String(new Date().getTime()),
      query: query,
      tag_active_set: tagActiveSet,
      tag_used_set: this.$store.state.ticket.tagUsedSet,
      history_query: this.$store.state.ticket.historyQuery,
      history_action_faq_channel: this.$store.state.ticket
        .historyActionFaqChannel,
      status: 'open',
    };
    return newTicket;
  }
  selectChoice({ choice, index }) {
    // Insert or replace the next index
    this.scenarios.splice(index + 1);
    this.scenarios.push(choice);
    this.publishFaqTicket(choice);
  }
}
</script>

<style lang="scss" scoped>
@import '../style/setting/variable';

.sai-list {
  margin: 0 !important;
  padding: 0 !important;
  position: relative;

  &:hover+li {
    .sai-faq-item {
      &__wrapper {
        border-top: 1px solid transparent !important;
        .mobile & {
          border-top: 1px solid #eee !important;
        }
      }
    }
  }
  &.selected+li {
    .sai-faq-item {
      &__wrapper {
        border-top: 1px solid transparent !important;
        .mobile & {
          border-top: 1px solid transparent !important;
        }
      }
    }
  }
  &.selected:hover+li {
    .sai-faq-item {
      &__wrapper {
        .mobile & {
          border-top: 1px solid transparent !important;
        }
      }
    }
  }
}

.sai-faq-item {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  .mobile & {
    transition: 0s;
  }

  .selected & {
    background-color: #c5fd5d !important;
  }

  &:hover {
    background-color: #c5fd5d;
    .mobile & {
      background-color: #fff;
    }
  }

  &__wrapper {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 0;
    margin: 0 16px;
    border-top: 1px solid #eee;

    .mobile & {
      display: none;
    }

    &.sp {
      display: none;
      .mobile & {
        display: block;
      }
    }

    .sai-faq-item:hover & {
      border-top: 1px solid transparent;
      .mobile & {
        border-top: 1px solid #eee;
      }
    }
    .selected & {
      border-top: 1px solid transparent !important;
    }
    .first & {
      border-top: 1px solid transparent;
    }

    &__content {
      .mobile & {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      &__title {
        &__text {
          font-family: $subFontFamily;
          font-size: 18px;
          font-weight: 700;
          padding: 6px 0 0 0;

          .mobile & {
            font-size: 16px;
          }

          span {
            font-weight: 600;
            font-size: 14px;
            display: inline-block;
            .mobile & {
              font-size: 12px;
            }
          }
        }
      }
      &__ancesters {
        display: block;
        color: #757575;
        font-size: 11px !important;
        &__ancester {
        }
      }
    }
    &__category {
      &__text {
        text-align: right;
        font-size: 12px;
        color: #2c2a2999;
        i {
          padding: 0 4px 0 0;
        }
        .mobile & {
          font-size: 12px;
        }
      }
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 23px;
    width: 23px;
    border-radius: 50%;
    background-color: #83c901;
    margin-right: 12px;

    .mobile & {
      margin-right: 8px;
    }
    img {
      width: 11px;
      height: 7px;
    }
  }
}

.sai-faq-result {
  border-top: 0px !important;
  background-color: #f1ffd8;
  padding-bottom: 16px;

  &::before {
    content: "";
    position: absolute;
    left: 5%;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-color: #c5fd5d transparent transparent transparent;
    border-width: 10px 10px 0 10px;
  }

  &__content {
    padding: 16px 32px 0 32px;
    .mobile & {
      padding: 16px 16px 0 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/FaqItem.vue